/* sucrase/dist/esm/parser/traverser/lval.js */ function _(require, module, exports, __esModule, __esExport) {
    __esModule();
    exports.parseSpread = parseSpread;
    exports.parseRest = parseRest;
    exports.parseBindingIdentifier = parseBindingIdentifier;
    exports.parseImportedIdentifier = parseImportedIdentifier;
    exports.markPriorBindingIdentifier = markPriorBindingIdentifier;
    exports.parseBindingAtom = parseBindingAtom;
    exports.parseBindingList = parseBindingList;
    exports.parseMaybeDefault = parseMaybeDefault;
    const flow_1 = require("9b8d43cd0a") /* ../plugins/flow */;
    const typescript_1 = require("6a970c22b9") /* ../plugins/typescript */;
    const index_1 = require("bfb18d0576") /* ../tokenizer/index */;
    const keywords_1 = require("99ff836c64") /* ../tokenizer/keywords */;
    const types_1 = require("f0c35cbd76") /* ../tokenizer/types */;
    const base_1 = require("540718e523") /* ./base */;
    const expression_1 = require("8178e7c3c8") /* ./expression */;
    const util_1 = require("bc94bbadc1") /* ./util */;
    function parseSpread() {
        (0, index_1.next)();
        (0, expression_1.parseMaybeAssign)(false);
    }
    function parseRest(isBlockScope) {
        (0, index_1.next)();
        parseBindingAtom(isBlockScope);
    }
    function parseBindingIdentifier(isBlockScope) {
        (0, expression_1.parseIdentifier)();
        markPriorBindingIdentifier(isBlockScope);
    }
    function parseImportedIdentifier() {
        (0, expression_1.parseIdentifier)();
        base_1.state.tokens[base_1.state.tokens.length - 1].identifierRole = index_1.IdentifierRole.ImportDeclaration;
    }
    function markPriorBindingIdentifier(isBlockScope) {
        let identifierRole;
        if (base_1.state.scopeDepth === 0) {
            identifierRole = index_1.IdentifierRole.TopLevelDeclaration;
        }
        else if (isBlockScope) {
            identifierRole = index_1.IdentifierRole.BlockScopedDeclaration;
        }
        else {
            identifierRole = index_1.IdentifierRole.FunctionScopedDeclaration;
        }
        base_1.state.tokens[base_1.state.tokens.length - 1].identifierRole = identifierRole;
    }
    // Parses lvalue (assignable) atom.
    function parseBindingAtom(isBlockScope) {
        switch (base_1.state.type) {
            case types_1.TokenType._this: {
                // In TypeScript, "this" may be the name of a parameter, so allow it.
                const oldIsType = (0, index_1.pushTypeContext)(0);
                (0, index_1.next)();
                (0, index_1.popTypeContext)(oldIsType);
                return;
            }
            case types_1.TokenType._yield:
            case types_1.TokenType.name: {
                base_1.state.type = types_1.TokenType.name;
                parseBindingIdentifier(isBlockScope);
                return;
            }
            case types_1.TokenType.bracketL: {
                (0, index_1.next)();
                parseBindingList(types_1.TokenType.bracketR, isBlockScope, true /* allowEmpty */);
                return;
            }
            case types_1.TokenType.braceL:
                (0, expression_1.parseObj)(true, isBlockScope);
                return;
            default:
                (0, util_1.unexpected)();
        }
    }
    function parseBindingList(close, isBlockScope, allowEmpty = false, allowModifiers = false, contextId = 0) {
        let first = true;
        let hasRemovedComma = false;
        const firstItemTokenIndex = base_1.state.tokens.length;
        while (!(0, index_1.eat)(close) && !base_1.state.error) {
            if (first) {
                first = false;
            }
            else {
                (0, util_1.expect)(types_1.TokenType.comma);
                base_1.state.tokens[base_1.state.tokens.length - 1].contextId = contextId;
                // After a "this" type in TypeScript, we need to set the following comma (if any) to also be
                // a type token so that it will be removed.
                if (!hasRemovedComma && base_1.state.tokens[firstItemTokenIndex].isType) {
                    base_1.state.tokens[base_1.state.tokens.length - 1].isType = true;
                    hasRemovedComma = true;
                }
            }
            if (allowEmpty && (0, index_1.match)(types_1.TokenType.comma)) {
                // Empty item; nothing further to parse for this item.
            }
            else if ((0, index_1.eat)(close)) {
                break;
            }
            else if ((0, index_1.match)(types_1.TokenType.ellipsis)) {
                parseRest(isBlockScope);
                parseAssignableListItemTypes();
                // Support rest element trailing commas allowed by TypeScript <2.9.
                (0, index_1.eat)(types_1.TokenType.comma);
                (0, util_1.expect)(close);
                break;
            }
            else {
                parseAssignableListItem(allowModifiers, isBlockScope);
            }
        }
    }
    function parseAssignableListItem(allowModifiers, isBlockScope) {
        if (allowModifiers) {
            (0, typescript_1.tsParseModifiers)([
                keywords_1.ContextualKeyword._public,
                keywords_1.ContextualKeyword._protected,
                keywords_1.ContextualKeyword._private,
                keywords_1.ContextualKeyword._readonly,
                keywords_1.ContextualKeyword._override,
            ]);
        }
        parseMaybeDefault(isBlockScope);
        parseAssignableListItemTypes();
        parseMaybeDefault(isBlockScope, true /* leftAlreadyParsed */);
    }
    function parseAssignableListItemTypes() {
        if (base_1.isFlowEnabled) {
            (0, flow_1.flowParseAssignableListItemTypes)();
        }
        else if (base_1.isTypeScriptEnabled) {
            (0, typescript_1.tsParseAssignableListItemTypes)();
        }
    }
    // Parses assignment pattern around given atom if possible.
    function parseMaybeDefault(isBlockScope, leftAlreadyParsed = false) {
        if (!leftAlreadyParsed) {
            parseBindingAtom(isBlockScope);
        }
        if (!(0, index_1.eat)(types_1.TokenType.eq)) {
            return;
        }
        const eqIndex = base_1.state.tokens.length - 1;
        (0, expression_1.parseMaybeAssign)();
        base_1.state.tokens[eqIndex].rhsEndIndex = base_1.state.tokens.length;
    }
}
